<template>
  <v-navigation-drawer permanent>
    <v-list dense nav>
      <!-- dashboard -->
      <v-list-item link @click="onListItem(0)">
        <v-list-item-icon>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- users -->
      <v-list-item link @click="onListItem(1)">
        <v-list-item-icon>
          <v-icon>mdi-account-group</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Users</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- products -->
      <v-list-item link @click="onListItem(2)">
        <v-list-item-icon>
          <v-icon>mdi-shape</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Products</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "merchantViewSidebar",
  data() {
    return {
      index: 0,
      selectedView: "dashboard",
    };
  },
  methods: {
    onListItem(index) {
      this.$emit("selectedIndexChange", index);
    },
  },
};
</script>

<style scoped>
.dashboard-wrapper {
  display: flex;
  flex-direction: row-reverse;
  align-content: center;
  padding: 10px;
}

.icons-wrapper {
  display: flex;
  height: 40px;
  justify-content: center;
}

.item-wrppaer {
  display: flex;
}
.dashboard-title {
  flex: 1;
}
</style>
